import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import logo from '../../assets/img/logo.png'; 
import { motion } from 'framer-motion';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext'; 
import { toast } from 'react-toastify';
import axios from 'axios';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');
    if (token && role === 'Super_Admin') {
      navigate('/SuperAdminDashboard');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();   
    try {
      const credentials = {
        email: email,
        password: password
      };

      const response = await axios.post(`${process.env.REACT_APP_SUPER_ADMIN_API_URL}superadminlogin.php`, credentials);

      if (response.data.status === 'success') {
        localStorage.setItem('role', response.data.role);
        localStorage.setItem('token', response.data.token);
        login(response.data.token, response.data.role);
        toast.success(response.data.message);
        navigate('/SuperAdminDashboard');
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error('An error occurred while logging in.');
      console.error('Login error:', error);
    }
  };

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center"
         style={{
           background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
           fontFamily: "'Poppins', sans-serif",
           padding: '2rem 0'
         }}>
      <div className="container">
        <div className="row align-items-center justify-content-center">
          {/* Login Card */}
          <motion.div
            className="col-md-6"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="card shadow-lg p-4"
                 style={{
                   borderRadius: '15px',
                   border: 'none',
                   background: 'rgba(255, 255, 255, 0.9)',
                   backdropFilter: 'blur(10px)',
                   height: '100%'
                 }}>
              <div className="text-center mb-4">
                <motion.div
                  initial={{ scale: 0.8 }}
                  animate={{ scale: 1 }}
                  transition={{ duration: 0.5 }}
                >
                  <img src={logo} alt="Logo" style={{ height: '100px', marginBottom: '1rem' }} />
                </motion.div>
                
                <h2 className="text-primary fw-bold mb-3" style={{ fontSize: '1.8rem' }}>Super Admin Login</h2>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label fw-medium">Email</label>
                  <div className="input-group">
                    <span className="input-group-text bg-light border-end-0" style={{ padding: '0.75rem 1rem' }}>
                      <i className="bi bi-envelope-fill text-primary" style={{ fontSize: '1.2rem' }}></i>
                    </span>
                    <input
                      type="email"
                      id="email"
                      className="form-control border-start-0"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      style={{ padding: '0.75rem' }}
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <label htmlFor="password" className="form-label fw-medium">Password</label>
                  <div className="input-group">
                    <span className="input-group-text bg-light border-end-0" style={{ padding: '0.75rem 1rem' }}>
                      <i className="bi bi-lock-fill text-primary" style={{ fontSize: '1.2rem' }}></i>
                    </span>
                    <input
                      type={showPassword ? "text" : "password"}
                      id="password"
                      className="form-control border-start-0"
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      style={{ padding: '0.75rem' }}
                    />
                    <button 
                      type="button" 
                      className="input-group-text bg-light border-start-0" 
                      onClick={() => setShowPassword(!showPassword)}
                      style={{ cursor: 'pointer' }}
                    >
                      <i 
                        className={showPassword ? "bi bi-eye-slash-fill" : "bi bi-eye-fill"} 
                        style={{ color: '#1976D2', fontSize: '1.2rem' }}
                      ></i>
                    </button>
                  </div>
                </div>

                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="form-check">
                    <input type="checkbox" className="form-check-input" id="rememberMe" />
                    <label className="form-check-label text-muted" htmlFor="rememberMe">
                      Remember me
                    </label>
                  </div>
                  <Link to="#" className="text-primary text-decoration-none">
                    Forgot password?
                  </Link>
                </div>

                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  type="submit"
                  className="btn btn-primary w-100 py-2 mb-3 fw-medium"
                  style={{
                    borderRadius: '8px',
                    background: 'linear-gradient(45deg, #2196F3, #1976D2)',
                    border: 'none',
                    fontSize: '1rem'
                  }}
                >
                  Login
                </motion.button>
              </form>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default Login;